import React from 'react';
import { css } from '@emotion/core';
import { Placement } from '@atlaskit/popper';
import Popup from '@atlaskit/popup';
import Button from '@atlaskit/button/standard-button';

import { useOpenableController } from '@/controllers';
import { flexCenter, popupContentStyles } from '@/styles';
import { FCC } from '@/utils/types';

const titleStyles = css`
  font-size: 11px;
`;

const buttonStyles = css`
  button {
    height: 20px;
    ${flexCenter};
    padding: 0 6px;
  }
`;

export type PopupLinkProps = {
  title?: string;
  icon?: React.ReactNode;
  placement?: Placement;
  triggerElement?: React.ReactNode;
  onToggle?: () => void;
};

const PopupLink: FCC<PopupLinkProps> = ({
  children,
  title,
  placement = 'bottom-start',
  icon,
  triggerElement,
  onToggle,
}) => {
  const openableController = useOpenableController();

  return (
    <Popup
      placement={placement}
      isOpen={openableController.isOpen}
      onClose={openableController.onClose}
      trigger={props =>
        triggerElement ? (
          <div
            {...props}
            onClick={e => {
              e.preventDefault();
              openableController.onToggle();
            }}
          >
            {triggerElement}
          </div>
        ) : (
          <span css={buttonStyles}>
            <Button
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...props}
              onClick={e => {
                e.preventDefault();
                openableController.onToggle();
                if (onToggle) onToggle();
              }}
            >
              <span css={flexCenter}>
                {icon}
                <span css={titleStyles}>{title}</span>
              </span>
            </Button>
          </span>
        )
      }
      content={() => <div css={popupContentStyles}>{children}</div>}
    />
  );
};

export default PopupLink;
